import type { WorkCalendar } from '@hana/work-calendar';

// Mint-HR-Attendance · logic thuần. Ca hành chính / ngày làm việc / T7 nửa ngày / lễ chỉ qua WorkCalendar (tblClientInfo);
// Ca kho / ca cảng là dữ liệu HR khai (hub.shift_template), không phải luật giờ làm việc. Chưa ghi DB.

export const YM = '2026-10';
export const NDAY = 31;
export const TODAY = 22;
export const DOW = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'] as const;
export const ymd = (d: number): string => `${YM}-${String(d).padStart(2, '0')}`;
export const dowOf = (d: number): number => new Date(`${ymd(d)}T00:00:00Z`).getUTCDay();
export const DAYS: readonly number[] = Array.from({ length: NDAY }, (_, i) => i + 1);

export type DayKind = 'off' | 'half' | 'work';
export function kindOf(cal: WorkCalendar, d: number): DayKind {
  const k = cal.dayKind(ymd(d));
  return k === 'work' || k === 'makeup' ? 'work' : k === 'halfDay' ? 'half' : 'off';
}

/** ok đủ công · M muộn · ! thiếu lượt · P phép · CT công tác · off nghỉ theo lịch · fut chưa tới */
export type Code = 'ok' | 'M' | '!' | 'P' | 'CT' | 'off' | 'fut';
export const CODE: Record<Code, { v: string; tone: 'ok' | 'warn' | 'err' | 'pri' | 'mute'; label: string }> = {
  ok: { v: '✓', tone: 'ok', label: 'Đủ công' }, M: { v: 'M', tone: 'warn', label: 'Đi muộn' }, '!': { v: '!', tone: 'err', label: 'Thiếu lượt chấm · chờ giải trình' },
  P: { v: 'P', tone: 'pri', label: 'Nghỉ phép (đơn đã duyệt)' }, CT: { v: 'CT', tone: 'mute', label: 'Công tác (đơn đã duyệt)' }, off: { v: '', tone: 'mute', label: 'Ngày nghỉ theo lịch tuần' }, fut: { v: '', tone: 'mute', label: 'Chưa tới' },
};
export type Branch = 'HCM' | 'HPH' | 'BDG';
export const BRANCHES: readonly (readonly [Branch | 'all', string])[] = [['all', 'Tất cả chi nhánh'], ['HCM', 'VP Cộng Hòa · HCM'], ['HPH', 'VP Hải Phòng'], ['BDG', 'Kho Bình Dương']];
export const BRANCH_NAME: Record<Branch, string> = { HCM: 'VP Cộng Hòa', HPH: 'VP Hải Phòng', BDG: 'Kho Bình Dương' };

export interface Staff { user: string; name: string; seat: string; branch: Branch; ex: Readonly<Record<number, Code>> }
const S = (user: string, name: string, seat: string, branch: Branch, ex: Record<number, Code>): Staff => ({ user, name, seat, branch, ex });
export const STAFF: readonly Staff[] = [
  S('PhuongHT', 'Hà Thanh Phương', 'CSD-BKG', 'HCM', { 9: 'P', 16: 'P' }), S('NhiTHT', 'Trần Hoàng Thảo Nhi', 'CSD-BKG', 'HCM', { 6: 'M', 20: 'M' }),
  S('MAITTN', 'Trần Thị Ngọc Mai', 'SALE-SE', 'HCM', { 15: 'CT', 21: 'CT' }), S('TUANNT', 'Nguyễn Thanh Tuấn', 'OPS-DOC', 'HCM', { 6: 'M', 14: '!', 17: '!' }),
  S('NhungTT', 'Thân Thị Nhung', 'ACC-TAX', 'HCM', { 12: 'P' }), S('AnNV', 'Nguyễn Văn An', 'OPS-FLD', 'HPH', { 3: 'M', 15: 'CT', 16: 'CT' }),
  S('ThangNV', 'Nguyễn Văn Thắng', 'OPS-FLD', 'HPH', { 8: '!', 22: 'M' }), S('HOATTN', 'Trần Thị Như Hoa', 'WH-OPS', 'BDG', { 19: 'P', 20: 'P' }),
  S('KHAINH', 'Nguyễn Hữu Khải', 'WH-OPS', 'BDG', { 7: 'M' }), S('BaoTQ', 'Trần Quốc Bảo', 'WH-FL', 'BDG', { 2: '!', 13: 'M' }),
];
export const CONFIRMED_DEFAULT: readonly string[] = ['PhuongHT', 'NhungTT', 'HOATTN', 'KHAINH', 'MAITTN'];

export function codeOf(cal: WorkCalendar, s: Staff, d: number, ov: Readonly<Record<string, Code>> = {}): Code {
  const o = ov[`${s.user}:${d}`];
  if (o) return o;
  if (kindOf(cal, d) === 'off') return 'off';
  if (d > TODAY) return 'fut';
  return s.ex[d] ?? 'ok';
}

export interface Totals { cong: number; late: number; miss: number; leave: number }
export function totals(cal: WorkCalendar, s: Staff, ov: Readonly<Record<string, Code>> = {}): Totals {
  const past = DAYS.filter((d) => d <= TODAY && kindOf(cal, d) !== 'off');
  const wd = (d: number) => (kindOf(cal, d) === 'half' ? 0.5 : 1);
  let cong = 0, late = 0, miss = 0, leave = 0;
  for (const d of past) {
    const c = codeOf(cal, s, d, ov);
    if (c === 'ok' || c === 'M' || c === 'CT') cong += wd(d);
    else if (c === '!') cong += wd(d) / 2;
    if (c === 'M') late += 1;
    if (c === '!') miss += 1;
    if (c === 'P') leave += wd(d);
  }
  return { cong, late, miss, leave };
}

export const norm = (x: string): string => x.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();
export function filterStaff(br: Branch | 'all', q: string): Staff[] {
  return STAFF.filter((s) => (br === 'all' || s.branch === br) && (!q || norm([s.user, s.name, s.seat].join(' ')).includes(norm(q))));
}
export const fmt1 = (x: number): string => (Math.round(x * 10) / 10).toFixed(1).replace('.', ',');

/** Giờ vào / ra mẫu cho ô công (dữ liệu giả lập, không phải luật giờ). */
export function punchOf(c: Code, d: number): [string, string] {
  const m: Partial<Record<Code, [string, string]>> = { ok: [`07:5${d % 9}`, `17:3${d % 7}`], M: [`08:1${d % 9}`, '17:35'], '!': ['07:58', '—'], P: ['—', '—'], CT: ['—', '—'] };
  return m[c] ?? ['—', '—'];
}
export const POINT_METHODS: Record<Branch, readonly string[]> = { HCM: ['Wifi', 'Khuôn mặt', 'GPS'], HPH: ['GPS', 'QR'], BDG: ['Khuôn mặt', 'QR'] };
export const EDIT_CODES: readonly (readonly [Code, string])[] = [['ok', 'Đủ công'], ['M', 'Đi muộn'], ['!', 'Thiếu lượt'], ['P', 'Phép'], ['CT', 'Công tác']];

// ---- Phân ca · ca kho / cảng do HR khai ----
export type ShiftCode = 'S' | 'C' | 'D' | 'HC' | 'N' | '_';
export const SHIFT: Record<Exclude<ShiftCode, '_'>, { k: string; sub: string; tone: 'ok' | 'warn' | 'pri' | 'mute' }> = {
  S: { k: 'Ca sáng kho', sub: '06:00–14:00', tone: 'ok' }, C: { k: 'Ca chiều kho', sub: '14:00–22:00', tone: 'warn' }, D: { k: 'Trực cảng đêm', sub: '22:00–06:00', tone: 'pri' },
  HC: { k: 'Hành chính', sub: 'WorkCalendar', tone: 'mute' }, N: { k: 'Nghỉ', sub: '', tone: 'mute' },
};
export const SHIFT_CYCLE: readonly ShiftCode[] = ['S', 'C', 'D', 'HC', 'N', '_'];
export const WEEK_DAYS = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'] as const;
export const WEEK_DATES: Record<number, readonly string[]> = { 45: ['02', '03', '04', '05', '06', '07', '08'], 46: ['09', '10', '11', '12', '13', '14', '15'] };
export const ROTA: readonly (readonly [string, string, Branch, string])[] = [
  ['HOATTN', 'Trần Thị Như Hoa', 'BDG', 'S S S C C N N'], ['KHAINH', 'Nguyễn Hữu Khải', 'BDG', 'C C C S S N N'], ['BaoTQ', 'Trần Quốc Bảo', 'BDG', 'S S _ _ C C N'],
  ['LIENNTK', 'Lê Nguyễn Thị Kim Liên', 'BDG', 'C _ S S S N N'], ['AnNV', 'Nguyễn Văn An', 'HPH', 'HC HC HC D D N N'], ['ThangNV', 'Nguyễn Văn Thắng', 'HPH', 'D D N HC HC HC N'],
  ['TUANNT', 'Nguyễn Thanh Tuấn', 'HCM', 'HC HC HC HC HC HC N'],
];
export const SHIFT_NEED = { S: 2, C: 2 } as const;
export function shiftOf(r: (typeof ROTA)[number], i: number, wk: number, ov: Readonly<Record<string, ShiftCode>> = {}): ShiftCode {
  const o = ov[`${wk}:${r[0]}:${i}`];
  if (o) return o;
  const p = r[3].split(' ');
  return (wk === 45 ? p[i] : (p[(i + 2) % 7] ?? 'N').replace('_', 'S')) as ShiftCode;
}
export function coverage(wk: number, ov: Readonly<Record<string, ShiftCode>> = {}) {
  return WEEK_DAYS.map((_, i) => {
    const n = (c: ShiftCode) => ROTA.filter((r) => shiftOf(r, i, wk, ov) === c).length;
    const s = n('S'), c = n('C'), d = n('D');
    return { s, c, d, short: i < 6 && (s < SHIFT_NEED.S || c < SHIFT_NEED.C) };
  });
}
export function countEmpty(rows: readonly (typeof ROTA)[number][], wk: number, ov: Readonly<Record<string, ShiftCode>> = {}): number {
  return rows.reduce((a, r) => a + WEEK_DAYS.filter((_, i) => shiftOf(r, i, wk, ov) === '_').length, 0);
}
/** Xoay ca mẫu "2 sáng · 2 chiều · nghỉ CN": điền các ô trống xen S / C. */
export function rotateFill(wk: number, ov: Readonly<Record<string, ShiftCode>> = {}): Record<string, ShiftCode> {
  const n: Record<string, ShiftCode> = { ...ov };
  ROTA.forEach((r, ri) => WEEK_DAYS.forEach((_, i) => { if (shiftOf(r, i, wk, ov) === '_') n[`${wk}:${r[0]}:${i}`] = (['S', 'C'] as const)[(ri + i) % 2]!; }));
  return n;
}

// ---- Điểm chấm ----
export type Method = 'gps' | 'wifi' | 'qr' | 'face';
export interface Point { code: string; name: string; addr: string; radius: number; on: Record<Method, boolean>; wifi: readonly string[]; faces: string }
export const POINTS: readonly Point[] = [
  { code: 'HCM', name: 'VP Cộng Hòa · HCM', addr: 'Tầng 6, 364 Cộng Hòa, Tân Bình', radius: 100, on: { gps: true, wifi: true, qr: false, face: true }, wifi: ['HANA-CH-5G', 'HANA-CH-2G'], faces: '34/36' },
  { code: 'HPH', name: 'VP Hải Phòng', addr: '15 Lê Thánh Tông, Ngô Quyền', radius: 150, on: { gps: true, wifi: false, qr: true, face: false }, wifi: ['HANA-HP'], faces: '—' },
  { code: 'BDG', name: 'Kho Bình Dương', addr: 'KCN Sóng Thần 2, Dĩ An', radius: 200, on: { gps: true, wifi: false, qr: true, face: true }, wifi: [], faces: '9/10' },
];
export const METHODS: readonly (readonly [Method, string, string])[] = [['gps', 'GPS', 'Trong bán kính điểm chấm'], ['wifi', 'Wifi', 'Bắt đúng mạng Wifi văn phòng'], ['qr', 'QR', 'Quét mã động tại quầy · đổi mỗi 30 giây'], ['face', 'Khuôn mặt', 'Máy chấm tại cửa hoặc camera điện thoại']];
export function methodDetail(p: Point, k: Method): string {
  if (k === 'gps') return `Bán kính ${p.radius} m · chặn vị trí giả lập`;
  if (k === 'wifi') return p.wifi.length ? p.wifi.join(' · ') : 'Chưa khai mạng';
  if (k === 'qr') return 'Mã động trên màn hình quầy · đổi mỗi 30 giây';
  return p.faces === '—' ? 'Chưa lắp máy' : `${p.faces} người đã đăng ký khuôn mặt`;
}
/** Số người còn thiếu đăng ký khuôn mặt (null nếu đủ / chưa lắp máy). */
export function faceMissing(p: Point): number | null {
  if (p.faces === '—') return null;
  const [a, b] = p.faces.split('/').map(Number);
  return a !== undefined && b !== undefined && a !== b ? b - a : null;
}
/** Lưới 21×21 minh hoạ mã QR (đổi mỗi 30 giây ở app thật). */
export function qrCells(): [number, number][] {
  const out: [number, number][] = [];
  for (let y = 0; y < 21; y++) for (let x = 0; x < 21; x++) {
    const F = ([[0, 0], [14, 0], [0, 14]] as const).find(([a, b]) => x >= a && x < a + 7 && y >= b && y < b + 7);
    let on: boolean;
    if (F) { const u = x - F[0], v = y - F[1]; on = u === 0 || u === 6 || v === 0 || v === 6 || (u >= 2 && u <= 4 && v >= 2 && v <= 4); } else on = (x * 7 + y * 13 + x * y) % 5 < 2;
    if (on) out.push([x, y]);
  }
  return out;
}

export interface Rules { late: number; early: number; fix: number; otR: '15' | '30'; out: 'block' | 'ask'; otNeed: boolean; photo: boolean }
export const RULES_DEFAULT: Rules = { late: 5, early: 5, fix: 3, otR: '15', out: 'ask', otNeed: true, photo: true };
export const clamp = (v: number, lo: number, hi: number): number => Math.max(lo, Math.min(hi, v));
